import React from 'react';
import './PageHeader.css';

const pageHeader = (props) => {
    return (
        <div className="PageHeader">
            <span>{props.title}</span>
        </div>
    );
};

export default pageHeader;


// WEBPACK FOOTER //
// ./src/components/PageHeader/PageHeader.js